import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { tags } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="container-main py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl text-white">虫虫漫画</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              虫虫漫画网致力于为广大漫画爱好者提供韩国漫画大全免费在线阅读服务，支持韩漫下拉式阅读模式，让您随时随地畅享无间断的漫画阅读旅程。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.filter((c) => c.slug !== 'all').map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors flex items-center gap-2"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {tags.map((tag) => (
                <Link
                  key={tag}
                  to={`/category/all`}
                  className="px-2.5 py-1 rounded-md text-xs bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors whitespace-nowrap"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="container-main py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 虫虫漫画网 chongchongmanhua.com - 韩国漫画大全免费在线阅读
          </p>
          <p className="text-xs text-foreground-500">
            本站所有漫画均来自网络，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}